<div class="my-auto height-full flex flex-column justify-content-center align-items-center">
  <div class="error-card flex flex-column align-items-start">
    <div class="error-card-header">
      <h1 class="text-2xl font-bold" style="color: #0f2765">
        {{ errorMessage }}
      </h1>
      <img src="assets/images/logos/mi-icon-logo-dark.png" alt="Logo" class="logo" width="17" />
    </div>
    <p class="text-sm text-gray-500 mt-0">Código de error: {{ data.statusCode }}</p>

    <div class="w-full"></div>
    <div class="w-full">
      <p class="text-lg" style="color: #0f2765">
        {{ errorDetails }}
      </p>
    </div>
    <div class="flex gap-2 w-full justify-content-end">
      <!-- <button miButton="primary" (click)="toLogin()">Ir al inicio</button> -->
    </div>
  </div>
</div>
